export type CustomerCardPreferencesFormType = MyBrokerApi.Preferences & {
    medicalWarningBypassed?: boolean;
};

export const customerCardPreferenceDefaultValues = (
    currentDetails: MyBrokerApi.PersonalDetails = null,
): CustomerCardPreferencesFormType => {
    return {
        commercialInfo: !!currentDetails?.newsSubscription,
        medicalInfo: !!currentDetails?.medicalData,
        securityInfo: !!currentDetails?.penalData,
        medicalWarningBypassed: true,
    };
};
